import { render, staticRenderFns } from "./cModalInsurance.vue?vue&type=template&id=5dd80c2d"
import script from "./cModalInsurance.vue?vue&type=script&lang=js"
export * from "./cModalInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports